.row {
    height: 40px;
    font-family: var(--mono-font-family);
}

.icon {
  height: 16px;
  width: 16px;
  fill: var(--gray-100);

  path {
    fill: var(--gray-100);
  }
}